import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/Homepage";
import Login from "./pages/login";
import Register from "./pages/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "react-hot-toast";
// import AddMember from "./pages/AddMember";
import MemberList from "./pages/MemberList";
import MemberEntryDetail from "./pages/MemberEntryDetail";
import MemberExitDetail from "./pages/MemberExitDetail";

import QrScan from "./pages/QrScan";
import History from "./pages/History";
import UserList from "./pages/UserList";
import Settings from "./pages/Settings";
import UserDetail from "./pages/userDetail";
import AddUser from "./pages/AddUser";
import FamilyDetail from "./pages/FamilyDetail";

import FamilyCard from "./pages/FamilyCard";
import ScanEntry from "./pages/ScanEntry";
import ScanExit from "./pages/ScanExit";
import SantymedProcessing from "./pages/SantymedProcessing";
import UpdateData from "./pages/UpdateData";
import Dashboard from "./pages/dashboard";
import Messages from "./pages/Messages";
import TIcketDetails from "./components/TIcketDetails";
import MemberNameDetail from "./pages/memberNameDetail";
import ForgotPassword from "./pages/ForgotPassword";

function App() {
  return (
    <>
      <BrowserRouter>
        <Toaster position="top-center" reverseOrder={false} />
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route
            path="/family-card"
            element={
              <ProtectedRoute>
                <FamilyCard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-user"
            element={
              <ProtectedRoute>
                <AddUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/member-list"
            element={
              <ProtectedRoute>
                <MemberList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-list"
            element={
              <ProtectedRoute>
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />

          <Route
            path="/member-detail-noms/:noms"
            element={
              <ProtectedRoute>
                <MemberNameDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/member-entry-detail/:matricule"
            element={
              <ProtectedRoute>
                <MemberEntryDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/member-exit-detail/:matricule"
            element={
              <ProtectedRoute>
                <MemberExitDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/family-detail/:matricule"
            element={
              <ProtectedRoute>
                <FamilyDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-detail/:user_id"
            element={
              <ProtectedRoute>
                <UserDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/scan-card"
            element={
              <ProtectedRoute>
                <QrScan />
              </ProtectedRoute>
            }
            key="qr-scan-key"
          />

          <Route
            path="/scan-entry"
            element={
              <ProtectedRoute>
                <ScanEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scan-exit"
            element={
              <ProtectedRoute>
                <ScanExit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/update-data"
            element={
              <ProtectedRoute>
                <UpdateData />
              </ProtectedRoute>
            }
          />

          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <History />
              </ProtectedRoute>
            }
          />

          <Route
            path="/database-processing"
            element={
              <ProtectedRoute>
                <SantymedProcessing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ticketdetails/:ticket_id"
            element={
              <ProtectedRoute>
                <TIcketDetails />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
